import {
  CloudDoneOutlined,
  EditOutlined,
  MailOutline,
  Visibility,
} from "@mui/icons-material";
import Event from "@mui/icons-material/Event";
import GetAppIcon from "@mui/icons-material/GetApp";
import {
  Autocomplete,
  Box,
  Checkbox,
  FormControl,
  IconButton,
  InputLabel,
  ListItem,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
  Zoom,
} from "@mui/material";
import Badge from "@mui/material/Badge";
import { DatePicker } from "@mui/x-date-pickers";
import { format, isValid, parseISO } from "date-fns";
import { es } from "date-fns/locale";
import { MaterialReactTable } from "material-react-table";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAvailableDocumentsToAdd } from "../../../actions/accidentDashboard";
import { postAppointment } from "../../../actions/appointments";
import { getConfidentialFields } from "../../../actions/fields";
import { auditarExportacion, CODIGO_AUDITORIA } from "../../../actions/audit";
import {
  openNewForm,
  setFormsGeneralProperties,
} from "../../../actions/formsState";
import { getFormatoFechaExportacion } from "../../../utils/datetimeUtils";
import { downloadCsv } from "../../../utils/filesUtils";
import snackbarUtils from "../../../utils/snackbarUtils";
import {
  getBoolParaExportacion,
  redactFromRegistroConfidentialFields,
} from "../../../utils/util";
import { StyledPendingAuthorizations } from "../../styled/authorizations";
import AddAppointment from "../../ui/accident/accidentDashboard/appointmentsCalendar/addAppointment";
import AppointmentSession from "../../ui/accident/accidentDashboard/appointmentsCalendar/session/appointmentSession";
import ConfirmDialog from "../dialog/confirmDialog";
import ModalFPAState from "../simpleModal/modalFPAState";
import { localization, tableConfig } from "./config/tableConfig";
import DetailsTableAuthorizations from "./utilsTable/detailsTableAuthorizations";
import TitleContainer from "./utilsTable/titleWithFetchData";

const appointmentModel = {
  fechaHora: null,
  especialidad: null,
  profesional: null,
  profesionalApellidoNombre: null,
  matricula: "",
  observacion: "",
  traslado: false,
  asistio: false,
};
const PendingAuthorizationsTable = ({
  data,
  namesArts,
  loading,
  error,
  fetchData,
  time,
  handleChangeTime,
  title,
  noRefresh,
  errorMessage,
  handleAccidentDetail,
  displayAccidents,
}) => {
  const dispatch = useDispatch();

  const documentation = useSelector(
    (state) => state.accidentDashboard.availableDocumentsToAdd,
  );

  const [openModalEstado, setOpenModalEstado] = useState(false);
  const [fptInAvailableDocummentsToAdd, setFptInAvailableDocummentsToAdd] =
    useState({});
  const [estadoSeleccionado, setEstadoSeleccionado] = useState("");
  const [fechaAutorizacionSeleccionada, setFechaAutorizacionSeleccionada] =
    useState(moment(new Date()).format("YYYY-MM-DDT00:00:00"));
  const [autorizacion, setAutorizacion] = useState(null);
  const [codigoAutorizacion, setCodigoAutorizacion] = useState("");
  const [observacionesAutorizacion, setobservacionesAutorizacion] =
    useState("");
  const [openAddAppointment, setOpenAddAppointment] = useState(false);
  const [appointmentsCollection, setAppointmentsCollection] = useState(false);
  const [openAppointmentSession, setOpenAppointmentSession] = useState(false);
  const [appointment, setAppointment] = useState();
  const [artId, setArtId] = useState(null);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [siniestro, setSiniestro] = useState(null);
  const [nroFormulario, setNroFormulario] = useState(null);
  const [rowDataState, setRowData] = useState({});
  const [isDownloadingCsv, setIsDownloadingCsv] = useState(false);

  useEffect(() => {
    if (siniestro != null && artId != null) {
      dispatch(getAvailableDocumentsToAdd(siniestro, artId));
    }
  }, [siniestro || artId]);
  useEffect(() => {
    if (documentation.data.length > 0) {
      setFptInAvailableDocummentsToAdd(
        documentation.data.find((f) => f.formulario === "Fpt"),
      );
    }
  }, [documentation.isFetching]);

  useEffect(() => {
    if (!errorMessage && !loading && !error) {
      handleCloseModalEstado();
    }
  }, [errorMessage]);

  useEffect(() => {
    if (autorizacion && autorizacion.fechaAutorizacion) {
      setFechaAutorizacionSeleccionada(
        moment(new Date(autorizacion.fechaAutorizacion)).format(
          "YYYY-MM-DDT00:00:00",
        ),
      );
    }
  }, [autorizacion]);

  const handleCloseConfirmDialog = () => {
    setConfirmDialogOpen(false);
  };

  const handleOpenConfirmDialog = () => {
    setConfirmDialogOpen(true);
  };

  const handleOpenAddAppointment = (rowData) => {
    setArtId(rowData.artMLCloud);
    setSiniestro(rowData.siniestroId);
    setNroFormulario(rowData.nroFormulario);
    dispatch(
      setFormsGeneralProperties({
        idArt: rowData.artMLCloud,
        idSiniestro: rowData.siniestroId,
        trabajador: rowData.apellidoTrabajador + ' ' + rowData.nombreTrabajador,
        apellidoTrabajador: rowData.apellidoTrabajador,
        nombreTrabajador: rowData.nombreTrabajador,
        documento: rowData.documento,
      }),
    );
    setRowData(rowData);
    setOpenAddAppointment(true);
  };

  const handleCloseAllDetails = () => {
    handleCloseAddAppointment();
    handleCloseConfirmDialog();
    handleCloseAppointmentSession();
    handleCloseModalEstado();
  };

  const handleCloseAddAppointment = () => {
    setOpenAddAppointment(false);
  };

  const handleSubmitAddAppointment = (appointment) => {
    if (appointmentsCollection) {
      // Componente AppointmentSession se encarga de crearlas, enviarlas y seteear FPT si es necesario
      setAppointment(appointment);
      setOpenAppointmentSession(true);
      handleCloseAddAppointment();
      setAppointmentsCollection(false);
    } else {
      appointment = {
        ...appointment,
        fechaHora: moment(appointment.fechaHora).format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ",
        ),
      };
      dispatch(
        postAppointment(appointment, artId, siniestro, nroFormulario),
      ).then((res) => {
        handleCloseAddAppointment();
        setAppointmentsCollection(false);
        snackbarUtils.success("Turno enviado correctamente");
        if (!noRefresh) {
          fetchData();
        }
        if (
          fptInAvailableDocummentsToAdd &&
          appointment.traslado &&
          new Date(appointment.fechaHora) >= new Date()
        ) {
          dispatch(
            openNewForm("Fpt", fptInAvailableDocummentsToAdd.nombre, {
              professionalName: appointment.profesionalApellidoNombre,
              specialityName: appointment.especialidadNombre,
              appointmentDates: [appointment.fechaHora],
              appointmentsIds: [res.value?.data?.idTurnoSiniestro],
            }),
          );
        }
      });
    }
  };

  const onAppointmentSessionCallback = (shouldOpenFpt) => {
    if (!noRefresh) fetchData();
  };

  const handleCloseAppointmentSession = () => {
    setOpenAppointmentSession(false);
  };

  const handleOpenModalEstado = (rowData) => {
    setAutorizacion(rowData);
    setCodigoAutorizacion(rowData.codigoAutorizacion);
    setobservacionesAutorizacion(rowData.observacionesAutorizacion);
    setOpenModalEstado(true);
  };

  const handleCloseModalEstado = () => {
    setAutorizacion(null);
    setOpenModalEstado(false);
    setEstadoSeleccionado("");
    setFechaAutorizacionSeleccionada(
      moment(new Date()).format("YYYY-MM-DDT00:00:00"),
    );
    setCodigoAutorizacion("");
    setobservacionesAutorizacion("");
  };

  const onUpdate = () => {
    fetchData(time);
  }

  const columns = [
    {
      header: "Art",
      accessorKey: "art",
      enableColumnActions: false,
      enableFiltering: true,
      size: 100,
      muiTableBodyCellProps: {
        sx: {
          fontSize: 12,
        },
      },

      maxSize: 100,
      Cell: ({ row }) => row.original.art.toUpperCase(),
      Filter: ({ column }) => (
        <Autocomplete
          multiple
          options={Object.values(namesArts ?? [])}
          value={column.getFilterValue() || []}
          onChange={(event, newValue) =>
            column.setFilterValue(newValue.length ? newValue : undefined)
          }
          getOptionLabel={(option) => option.nombreCorto}
          renderInput={(params) => (
            <TextField
              {...params}
              sx={{
                "& .MuiInputBase-root": {
                  minHeight: 35,
                  marginTop: 4,
                },
                "& .MuiOutlinedInput-input ": {
                  padding: "5px 10px",
                  fontSize: "0.875rem",
                },
                "& .MuiChip-root": {
                  height: 20,
                  fontSize: "0.75rem",
                  margin: "2px",
                },
                "& .MuiAutocomplete-input": {
                  padding: "5px 10px",
                  fontSize: "0.875rem",
                },
                "& .MuiAutocomplete-popover": {
                  maxHeight: 250,
                  overflowY: "auto",
                },
              }}

              variant="standard"
              fullWidth
            />
          )}
          disableCloseOnSelect
          renderOption={(props, option, { selected }) => (
            <ListItem {...props} key={option.id}>
              <Checkbox
                size="sm"
                checked={selected}
                sx={{
                  padding: 0,
                  margin: 0,
                  marginRight: 0.5,
                  marginLeft: -1,
                }}
              />
              <Typography variant="body2">{option.nombreCorto}</Typography>
            </ListItem>
          )}
        />
      ),
      filterFn: (row, id, filterValue) => {
        if (!filterValue || filterValue.length === 0) return true;
        const rowValue = row.original.artMLCloud;
        return filterValue.some((value) => rowValue == value.id);
      },
    },
    {
      header: "Fecha",
      accessorKey: "fecha",
      filterFn: (row, columnId, filterValue) => {
        if (!filterValue) return true;
        const cellDate = parseISO(row.original[columnId]);
        if (!isValid(cellDate)) return false;
        return format(cellDate, "dd/MM/yyyy", { locale: es }) === filterValue;
      },
      muiTableBodyCellProps: {
        sx: {
          fontSize: 12,
        },
      },
      Cell: ({ row }) => {
        const date = parseISO(row.original.fecha);
        return isValid(date) ? format(date, "dd/MM/yyyy", { locale: es }) : "";
      },
      Filter: ({ column }) => {
        const [selectedDate, setSelectedDate] = useState(null);

        return (
          <DatePicker
            value={selectedDate}
            slotProps={{
              textField: {
                variant: "standard",
                sx: {
                  "& .MuiInputBase-root": {
                    height: 35,
                    minWidth: 70,
                    marginTop: 4,
                  },
                  "& .MuiOutlinedInput-input ": {
                    height: 5,
                  },
                  "& .MuiChip-root": {
                    height: 1,
                  },
                },
              },
            }}
            onChange={(newDate) => {
              setSelectedDate(newDate);
              column.setFilterValue(
                newDate
                  ? format(newDate, "dd/MM/yyyy", { locale: es })
                  : undefined,
              );
            }}
            renderInput={(params) => (
              <TextField {...params} size="small" fullWidth />
            )}
          />
        );
      },
      enableColumnActions: false,
    },
    {
      header: "Siniestro",
      accessorKey: "siniestro",
      muiTableBodyCellProps: {
        sx: {
          whiteSpace: "normal",
          fontSize: 12,
          wordWrap: "break-word",
        },
      },
      Cell: ({ row }) =>
        row.original.siniestro === 0 ? " " : row.original.siniestro,
      enableColumnActions: false,
      Filter: ({ column }) => (
        <TextField
          variant="standard"
          fullWidth
          sx={{
            "& .MuiInputBase-root": {
              height: 35,
              marginTop: 4,
            },
            "& .MuiOutlinedInput-input": {
              height: 5,
            },
          }}
          value={column.getFilterValue() || ""}
          onChange={(e) => column.setFilterValue(e.target.value)}
        />
      ),
    },
    {
      header: "Documento",
      accessorKey: "documento",
      enableColumnActions: false,
      muiTableBodyCellProps: {
        sx: {
          whiteSpace: "normal",
          fontSize: 12,
          wordWrap: "break-word",
        },
      },
      Filter: ({ column }) => (
        <TextField
          variant="standard"
          fullWidth
          sx={{
            "& .MuiInputBase-root": {
              height: 35,
              marginTop: 4,
            },
            "& .MuiOutlinedInput-input": {
              height: 5,
            },
          }}
          value={column.getFilterValue() || ""}
          onChange={(e) => column.setFilterValue(e.target.value)}
        />
      ),
    },
    {
      header: "Trabajador",
      accessorFn: (row) =>
        `${row.apellidoTrabajador || ""}, ${row.nombreTrabajador || ""}`,
      enableColumnActions: false,

      filterFn: (row, columnId, filterValue) => {
        const fullName = `${row.original.apellidoTrabajador || ""}, ${row.original.nombreTrabajador || ""
          }`.toLowerCase();

        return fullName.includes(filterValue.toLowerCase());
      },
      Cell: ({ row }) =>
        `${row.original.apellidoTrabajador}, ${row.original.nombreTrabajador}`,
      muiTableBodyCellProps: {
        sx: {
          whiteSpace: "normal",
          fontSize: 12,
          wordWrap: "break-word",
        },
      },
      Filter: ({ column }) => (
        <TextField
          variant="standard"
          fullWidth
          sx={{
            "& .MuiInputBase-root": {
              height: 35,
              marginTop: 4,
            },
            "& .MuiOutlinedInput-input": {
              height: 5,
            },
          }}
          value={column.getFilterValue() || ""}
          onChange={(e) => column.setFilterValue(e.target.value)}
        />
      ),
    },
    {
      header: "Empleador",
      accessorKey: "empresa",
      muiTableBodyCellProps: {
        sx: {
          whiteSpace: "normal",
          fontSize: 11,
          wordWrap: "break-word",
        },
      },
      enableColumnActions: false,
      Filter: ({ column }) => (
        <TextField
          variant="standard"
          fullWidth
          sx={{
            "& .MuiInputBase-root": {
              height: 35,
              minHeight: "unset",
              marginTop: 4,
            },
            "& .MuiOutlinedInput-input": {
              height: 5,
            },
          }}
          value={column.getFilterValue() || ""}
          onChange={(e) => column.setFilterValue(e.target.value)}
        />
      ),
    },
    {
      header: "Detalle",
      accessorKey: "detalle",
      enableSorting: false,
      enableColumnActions: false,
      enableColumnFilter: false,
      accessorFn: (row) => row.detalle || "", // Asegurar que el texto completo se use en el filtrado y ordenamiento
      Cell: ({ row }) => {
        const { detalle } = row.original;

        return detalle?.length > 20 ? (
          <Tooltip title={detalle} TransitionComponent={Zoom} arrow>
            <Typography
              variant="caption"
              sx={{
                whiteSpace: "normal", // Ajustar contenido en las celdas
                wordWrap: "break-word",
                fontSize: 11,
              }}>
              {detalle.substring(0, 20)} <b>[...ver más]</b>
            </Typography>
          </Tooltip>
        ) : (
          <Typography variant="caption">{detalle || ""}</Typography>
        );
      },

      filterFn: (row, columnId, filterValue) => {
        if (!filterValue) return true; // No aplicar filtro si el valor está vacío
        return row.original.detalle
          ?.toLowerCase()
          .includes(filterValue.toLowerCase());
      },
    },
    {
      header: (
        <Typography
          sx={{
            ...localization.headerStyle,
            fontWeight: "bold",
            whiteSpace: "normal",
            wordWrap: "break-word",
            maxWidth: 55,
          }}>
          En otra institución
        </Typography>
      ),
      accessorKey: "enOtraInstitucion",
      Cell: ({ row }) => (row.original.enOtraInstitucion ? "Sí" : "No"),
      Filter: ({ column }) => (
        <Select
          fullWidth
          variant="standard"
          sx={{
            minWidth: 50,
            minHeight: 35,
            textAlign: "start",
            marginTop: 1.4,
          }}
          value={column.getFilterValue() || ""}
          onChange={(e) => column.setFilterValue(e.target.value || undefined)}
          displayEmpty>
          <MenuItem value="">Todos</MenuItem>
          <MenuItem value="true">Sí</MenuItem>
          <MenuItem value="false">No</MenuItem>
        </Select>
      ),
      filterFn: (row, id, filterValue) => {
        const value = row.getValue(id);
        return filterValue === "true" ? value === true : value === false;
      },
      enableColumnActions: false,
    },
    {
      header: (
        <Typography
          sx={{
            ...localization.headerStyle,
            fontWeight: "bold",
            whiteSpace: "normal",
            wordWrap: "break-word",
            width: 45,
          }}>
          Recibido por la ART
        </Typography>
      ),
      grow: false,
      maxSize: 50,
      accessorKey: "recibidoPorLaArt",
      filterFn: (row, columnId, filterValue) => {
        if (!filterValue) return true;
        const cellDate = parseISO(row.original[columnId]);
        if (!isValid(cellDate)) return false;
        return format(cellDate, "dd/MM/yyyy", { locale: es }) === filterValue;
      },
      Filter: ({ column }) => {
        const [selectedDate, setSelectedDate] = useState(null);

        return (
          <DatePicker
            value={selectedDate}
            slotProps={{
              textField: {
                variant: "standard",
                sx: {
                  "& .MuiInputBase-root": {
                    height: 35,
                    marginTop: -1.3,
                  },
                  "& .MuiOutlinedInput-input ": {
                    height: 5,
                  },
                  "& .MuiChip-root": {
                    height: 1,
                  },
                },
              },
            }}
            onChange={(newDate) => {
              setSelectedDate(newDate);
              column.setFilterValue(
                newDate
                  ? format(newDate, "dd/MM/yyyy", { locale: es })
                  : undefined,
              );
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                fullWidth
                value={column.getFilterValue() || ""}
              />
            )}
          />
        );
      },
      enableColumnActions: false,

      Cell: ({ row }) => {
        const { recibidoPorLaArt, enviadoPorCorreoArt } = row.original;
        if (!recibidoPorLaArt) return "";
        return (
          <StyledPendingAuthorizations.RecibidoPorLaArtContainer>
            <StyledPendingAuthorizations.RecibidoPorLaArtDate>
              {moment(recibidoPorLaArt).format("DD/MM/YYYY")}
            </StyledPendingAuthorizations.RecibidoPorLaArtDate>
            <Tooltip
              title={
                enviadoPorCorreoArt
                  ? "Enviado por mail"
                  : "Enviado por servicio"
              }
              TransitionComponent={Zoom}
              arrow>
              {enviadoPorCorreoArt ? (
                <MailOutline fontSize="small" />
              ) : (
                <CloudDoneOutlined fontSize="small" />
              )}
            </Tooltip>
          </StyledPendingAuthorizations.RecibidoPorLaArtContainer>
        );
      },
    },
    {
      header: "Con turnos",
      enableSorting: false,
      accessorKey: "conTurnos",
      Cell: ({ row }) => {
        const { editable, cantidadTurnos } = row.original;
        return (
          <Tooltip
            title={editable ? "Agregar Turno" : "Agregar Turno (Deshabilitado)"}
            arrow>
            <IconButton
              color="inherit"
              disabled={!editable}
              onClick={() => handleOpenAddAppointment(row.original)}>
              <Badge
                fontSize="small"
                badgeContent={cantidadTurnos || 0}
                color="primary">
                <Event
                  fontSize="small"
                  sx={`${StyledPendingAuthorizations.icon} ${!editable ? StyledPendingAuthorizations.disabledButton : {}
                    }`}
                />
              </Badge>
            </IconButton>
          </Tooltip>
        );
      },
      enableColumnActions: false,

      Filter: ({ column }) => (
        <Select
          fullWidth
          variant="standard"
          sx={{
            minHeight: 35,
            textAlign: "start",
            marginTop: 4,
          }}
          value={column.getFilterValue() || ""}
          onChange={(e) => column.setFilterValue(e.target.value || undefined)}
          displayEmpty>
          <MenuItem value="">Todos</MenuItem>
          <MenuItem value="true">Sí</MenuItem>
          <MenuItem value="false">No</MenuItem>
        </Select>
      ),
      filterFn: (row, id, filterValue) => {
        const value = row.getValue(id);
        return filterValue === "true" ? value === true : value === false;
      },
    },
    {
      header: "Acciones",
      accessorKey: "acciones",
      enableColumnActions: false,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => (
        <Box display="flex" alignItems="center">
          <Tooltip title="Ver detalles" arrow="top">
            <IconButton
              color="inherit"
              onClick={() => handleAccidentDetail(row.original)}>
              <Visibility sx={StyledPendingAuthorizations.icon} />
            </IconButton>
          </Tooltip>

          <Tooltip title="Editar estado" arrow="top">
            <IconButton
              color="inherit"
              disabled={!row.original.editable}
              onClick={() => handleOpenModalEstado(row.original)}>
              <EditOutlined sx={StyledPendingAuthorizations.icon} />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ];

  const formatTableDataForExport = (table) => {
    const tableDataWithFormat = table.map((fila) => [
      fila.art ? `"${fila.art}"` : "",
      getFormatoFechaExportacion(fila.fecha, "dd/MM/yyyy"),
      fila.siniestro ? `"${fila.siniestro}"` : "",
      fila.documento ? `"${fila.documento}"` : "",
      fila.nombreTrabajador + " " + fila.apellidoTrabajador,
      fila.empresa ? `"${fila.empresa}"` : "",
      fila.detalle ? `"${fila.detalle}"` : "",
      getBoolParaExportacion(fila.enOtraInstitucion),
      getFormatoFechaExportacion(fila.recibidoPorLaArt, "dd/MM/yyyy"),
    ]);

    return tableDataWithFormat;
  };

  const handleExportToCsv = () => {
    setIsDownloadingCsv(true);

    dispatch(auditarExportacion(data, "artMLCloud", CODIGO_AUDITORIA.EXPORTACION_AUTORIZACIONES_PENDIENTES))
      .then(() => dispatch(getConfidentialFields("autorizaciones")))
      .then((res) => {
        const redactedData = data.map((row) => {
          return redactFromRegistroConfidentialFields(
            row,
            res.value.data,
            "artMLCloud",
          );
        });

        const encabezado = [
          "Art",
          "Fecha",
          "Siniestro",
          "Documento",
          "Trabajador",
          "Empleador",
          "Detalle",
          "En otra institucion",
          "Recibido por la ART",
        ];

        const formattedDataAsCsv = [
          encabezado,
          ...formatTableDataForExport(redactedData),
        ];

        let csvContent = "sep=,\n";
        csvContent += `${formattedDataAsCsv
          .map((e) => e.join(","))
          .join("\n")}`;

        downloadCsv(csvContent, `Autorizaciones${title}`);
        snackbarUtils.success(
          "Las autorizaciones han sido descargadas con éxito.",
        );
        setIsDownloadingCsv(false);
      })
      .catch((err) => {
        snackbarUtils.error(err);
        setIsDownloadingCsv(false);
      });
  };
  return (
    <>
      {displayAccidents !== "block" ? (
        <></>
      ) : (
        <MaterialReactTable
          {...tableConfig}
          enableStickyHeader
          enableExpandAll={false}
          defaultColumn={{
            maxSize: 50,
            grow: false,
          }}
          columns={columns}
          data={data}
          state={{ isLoading: loading || isDownloadingCsv }}
          renderTopToolbarCustomActions={() => (
            <div>
              <Box m={0.5} width={10} display="flex">
                <TitleContainer
                  title={title}
                  noRefresh={noRefresh}
                  fetchData={fetchData}
                />
                <Tooltip title="Exportar CSV" arrow="top">
                  <IconButton sx={{ margin: 2 }} onClick={handleExportToCsv}>
                    <GetAppIcon />
                  </IconButton>
                </Tooltip>
              </Box>
              {time && (
                <div>
                  <FormControl
                    sx={{ margin: 1, minWidth: 250 }}
                    variant="standard">
                    <InputLabel>Duración</InputLabel>
                    <Select onChange={handleChangeTime} value={time}>
                      <MenuItem value={2}>48 horas</MenuItem>
                      <MenuItem value={7}>7 días</MenuItem>
                      <MenuItem value={30}>30 días</MenuItem>
                      <MenuItem value={100}>100 días</MenuItem>
                    </Select>
                  </FormControl>
                </div>
              )}
            </div>
          )}
          muiTableHeadCellProps={{
            sx: {
              ...tableConfig.muiTableHeadCellProps.sx,
              padding: 0.6,
              fontSize: 12,
            },
          }}
          muiSelectCheckboxProps={{
            sx: {
              maxWidth: 5,
            },
          }}
          initialState={{
            showColumnFilters: true,
            density: "compact", // Valores posibles: 'compact', 'comfortable', 'spacious'
            columnOrder: [
              "Art",
              "Fecha",
              "Siniestro",
              "Documento",
              "Trabajador",
              "Empleador",
              "En otra institución",
              "Recibido por la ART",
              "Con turnos",
              "Acciones",
            ],
          }}
          renderDetailPanel={({ row }) => {
            return (
              <StyledPendingAuthorizations.DetailsTableAuthorizationsContainer>
                <DetailsTableAuthorizations rowData={row.original} />
              </StyledPendingAuthorizations.DetailsTableAuthorizationsContainer>
            );
          }}
        />
      )}
      <div>
        <ModalFPAState
          open={openModalEstado}
          handleClose={handleCloseModalEstado}
          handleOpenConfirmDialog={handleOpenConfirmDialog}
          autorizacion={autorizacion}
          estadoSeleccionado={estadoSeleccionado}
          setEstadoSeleccionado={setEstadoSeleccionado}
          fechaAutorizacionSeleccionada={fechaAutorizacionSeleccionada}
          setFechaAutorizacionSeleccionada={setFechaAutorizacionSeleccionada}
          codigoAutorizacion={codigoAutorizacion}
          setCodigoAutorizacion={setCodigoAutorizacion}
          observacionesAutorizacion={observacionesAutorizacion}
          setobservacionesAutorizacion={setobservacionesAutorizacion}
          isAnswered={false}
          disabled={loading}
          onUpdate={onUpdate}
        />
        <AddAppointment
          open={openAddAppointment}
          handleClose={handleCloseAddAppointment}
          handleOpenConfirmDialog={handleOpenConfirmDialog}
          appointmentModel={appointmentModel}
          handleSubmit={handleSubmitAddAppointment}
          artId={artId}
          openInCalendar={true}
          openAppointmentCollection={() => setAppointmentsCollection(true)}
          preloadedProfessional={rowDataState.solicitadoPor}
        />
        <AppointmentSession
          appointment={appointment}
          open={openAppointmentSession}
          handleClose={handleCloseAppointmentSession}
          handleOpenConfirmDialog={handleOpenConfirmDialog}
          artId={artId}
          siniestro={siniestro}
          nroFormulario={nroFormulario}
          callBack={onAppointmentSessionCallback}
          hasFpt={!!fptInAvailableDocummentsToAdd}
          trabajador={rowDataState.apellidoTrabajador + ' ' + rowDataState.nombreTrabajador}
        />
      </div>
      <div>
        <ConfirmDialog
          open={confirmDialogOpen}
          handleClose={handleCloseConfirmDialog}
          handleConfirm={handleCloseAllDetails}
          title="CERRAR VENTANA"
          text="¿Está seguro que desea cancelar esta operación? En caso de aceptar, se perderá la información ingresada"
        />
      </div>
    </>
  );
};

export default PendingAuthorizationsTable;
